import React, { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';

export default function MyProfile() {
  const { user, request, signedOut } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  useEffect(() => {
    request('get', '/account/profile').then(data => setProfile(data.profile)).catch(err => setError(err.message)).finally(() => setLoading(false));
  }, [request]);
  async function save(event) {
    event.preventDefault(); setBusy(true); setError(''); setMessage('');
    try { await request('put', '/account/profile', profile); setMessage('Profile saved.'); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  async function changePassword(event) {
    event.preventDefault(); setError(''); setMessage('');
    if (password !== confirm) { setError('New passwords do not match.'); return; }
    setBusy(true);
    try { await request('post', '/account/password', { currentPassword, password }); setBusy(false); signedOut(); return; }
    catch (err) { setError(err.message); }
    setBusy(false);
  }
  return <main className="account-page">
    <h1>My profile</h1><p>Signed in as {user.username}</p>
    {error && <p role="alert">{error}</p>}{message && <p role="status">{message}</p>}
    {loading ? <p role="status">Loading profile…</p> : profile ? <form className="account-form" onSubmit={save}>
      <label>Player name<input required maxLength={64} value={profile.player_name} onChange={e => setProfile({ ...profile, player_name: e.target.value })} /></label>
      <label>Profile picture URL<input type="url" maxLength={2048} value={profile.profile_picture || ''} onChange={e => setProfile({ ...profile, profile_picture: e.target.value })} /></label>
      <button disabled={busy}>Save profile</button>
    </form> : <p>Ask an administrator to link your account to a player profile before editing your profile or submitting runs.</p>}
    <section><h2>Change password</h2><p>You will need to log in again after changing your password.</p>
      <form className="account-form" onSubmit={changePassword}>
        <label>Current password<input type="password" autoComplete="current-password" required maxLength={128} value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} /></label>
        <label>New password (15–128 characters)<input type="password" autoComplete="new-password" required minLength={15} maxLength={128} value={password} onChange={e => setPassword(e.target.value)} /></label>
        <label>Confirm new password<input type="password" autoComplete="new-password" required minLength={15} maxLength={128} value={confirm} onChange={e => setConfirm(e.target.value)} /></label>
        <button disabled={busy}>Change password</button>
      </form>
    </section>
  </main>;
}
